import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
  scheduleSlug: string;
};

export const ScheduleEditPage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, siteSlug, scheduleSlug }) => {
  const breadcrumbs = useMemo(
    () => [
      {
        label: "スケジュール",
        path: `/sites/${siteSlug}/settings?tab=schedules`,
      },
      {
        label: "スケジュール編集",
        path: `/sites/${siteSlug}/schedules/${scheduleSlug}/edit`,
      },
    ],
    [scheduleSlug, siteSlug]
  );

  return (
    <PageLayout title="スケジュール編集" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
